import { Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

export default function Header() {
  const { isAuthenticated } = useAuth();
  const headerStyles = {
    backgroundColor: '#f5f5f5',
    borderRadius: '12px',
    padding: '12px 20px',
    margin: '20px auto',
    maxWidth: '1200px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  };

  const logoStyles = {
    color: '#000',
    fontSize: '20px',
    fontWeight: 600,
    textDecoration: 'none',
    display: 'flex',
    alignItems: 'center',
  };

  const navStyles = {
    display: 'flex',
    alignItems: 'center',
    paddingLeft: '36px',
    gap: '12px',
  };

  const linkStyles = {
    color: '#000',
    fontSize: '16px',
    fontWeight: 400,
    textDecoration: 'none',
  };

  return (
    <header style={headerStyles}>
      <Link to="/" style={logoStyles}>
        <span style={{ color: '#f97316', fontWeight: 700 }}>Supa</span><span>server</span>
      </Link>
      <nav style={navStyles}>
        <Link to="/how-it-works" style={linkStyles}>
          How It Works
        </Link>
        {/* <Link to="/pricing" style={linkStyles}>
          Pricing
        </Link> */}
        {!isAuthenticated && (
          <Link to="/login" style={linkStyles}>
            Log in
          </Link>
        )}
      </nav>
    </header>
  );
}

